import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { AuthState, IUser } from "../../types/auth-reducer-types";
import { RootState } from "../store";
import { endCodeLoginSession } from "../../utils/codeLogin";

const initialState: AuthState = {
  user: null,
  isAuthenticated: false,
  expired: false,
  isKeepLogin: true,
  canceled: false,
  isPaddle: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      endCodeLoginSession(); // email-code login only: ends the server session (not awaited) and clears its keys
      localStorage.removeItem("accessToken");
      state = initialState;
      return state;
    },
    setUser: (state, action: PayloadAction<IUser>) => {
      state.user = action.payload;
      state.isAuthenticated = action.payload.tempPass === "0";
      return state;
    },
    setIsKeepLogin: (state, action: PayloadAction<boolean>) => {
      state.isKeepLogin = action.payload;
      return state;
    },
    updateUserEmail: (state, action: PayloadAction<string>) => {
      if (state.user) {
        state.user.email = action.payload;
      }
      return state;
    },
    updateLicenseExpiredType: (state, action: PayloadAction<boolean>) => {
      state.expired = action.payload;
    },
    updateLicenseCanceledType: (state, action: PayloadAction<boolean>) => {
      state.canceled = action.payload;
    },
    isUserPaddle: (state, action: PayloadAction<boolean>) => {
      state.isPaddle = action.payload;
    },
  },
});

// Selector function to get isKeepLogin
export const selectIsKeepLogin = (state: RootState) => state.auth.isKeepLogin;

// Action creators are generated for each case reducer function
export const { logout, setUser, setIsKeepLogin, updateUserEmail, updateLicenseCanceledType, updateLicenseExpiredType, isUserPaddle } =
  authSlice.actions;

export default authSlice.reducer;
export const selectIsAuthenticated = (state: RootState) => state.auth.isAuthenticated;
export const selectUser = (state: RootState) => state.auth.user;
